<template>
    <div class="color">
        <article class="adwqrc">

            <div class="main">

                <h1>{{ $t('landing_consent_banner_title') }}</h1>

                <p>{{ $t('landing_consent_banner_description') }}</p>

                <label for="mail-input">
                    <input id="mail-input"
                           type="email"
                           ref="inputWithoutQRCode"
                           :placeholder="$t('landing_email_placeholder')"
                           v-on:keyup.enter="goLogin">
                    <button @click="goLogin">
                        <span :class="{'requesting': requesting}">{{ $t('landing_consent_banner_cta') }}</span>
                        <lottie-loader class="input-loader" :class="{'show-loader': requesting}"
                                       :size="22"></lottie-loader>
                    </button>
                    <img src="/img/landing/v4/shine-right.png">

                </label>
            </div>

            <div class="footer">

                <a href="#privacy">{{ $t('consent_your_data') }}</a>

            </div>

        </article>
    </div>

</template>

<script>
import LottieLoader from '../lottie/LottieLoader'

export default {

    name: 'article-1-desktop-without-q-r-code',

    components: {LottieLoader},

    props: {
        requesting: {
            type: Boolean,
            default: false
        }
    },

    methods: {

        goLogin() {
            this.$emit('goLogin', this.$refs.inputWithoutQRCode.value, 'connect_email')
        }
    }
}
</script>

<style lang="scss" scoped>

.adwqrc {
    padding-top: 80px;
    display: flex;
    flex-direction: column;
    background-image: url('/img/background/landing-v4-desktop-background.svg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    .main {
        color: $white;
        padding: 200px 16px;
        display: flex;
        flex: 1;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        text-shadow: 0px 0px 25px rgba(0, 0, 0, 0.10);
        z-index: 1;
        position: relative;

        h1 {
            font-size: 36px;
            font-weight: 700;
            line-height: 41px;
        }

        p {
            max-width: 860px;
            margin-top: 16px;
            font-size: 22px;
            font-weight: 500;
            line-height: 140%;
        }

        label {
            width: 100%;
            max-width: 644px;
            position: relative;
            margin-top: 32px;
            padding: 4px 4px 4px 24px;
            display: flex;
            flex-direction: row;
            align-items: center;
            background-color: $white;
            border-radius: 32px;
            box-shadow: 0px 25px 50px 0px rgba(0, 0, 0, 0.10);

            input {
                flex: 1;
                font-size: 16px;
                font-weight: 500;
                line-height: 140%;
                margin-right: 2px;
            }

            button {
                min-width: 55px;
                background-color: $lime;
                border-radius: 32px;
                padding: 16px 24px;
                font-size: 16px;
                font-weight: 700;
                line-height: 140%;
                color: $white;
                display: flex;
                align-items: center;
                justify-content: center;

                .requesting {
                    visibility: hidden;
                }

                .input-loader {
                    visibility: hidden;
                    position: absolute;
                }

                .show-loader {
                    visibility: visible;
                }

                &:hover {
                    background-color: $green-hover;
                }

                &:active {
                    background-color: $green-active;
                }
            }

            img {
                position: absolute;
                right: -35px;
                width: 24px;
            }
        }
    }

    .footer {
        padding-bottom: 40px;

        a {
            color: $white;
            font-size: 17px;
            font-weight: 700;
            line-height: 140%;
            text-decoration-line: underline;
        }
    }
}

.color {
    background-color: $blue;
}
</style>

